/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { Modal, Alert, Button } from 'react-bootstrap';
import styled from 'styled-components';
import '../formas/styles.scss';

const ModalBloqueoEmision = ({ bloquear = false, msgError='' }) => {
  const [modalShow, setModalShow] = useState(false);
  useEffect(() => {
    if (bloquear) {
      setModalShow(true);
    }
  
  }, []);
  return (
    <React.Fragment>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>          
        </Modal.Header>
        <Modal.Body>
          <Alert key={'124521'} variant={'warning'}>
            <p style={{fontSize:"20px"}}>
              {msgError}
            </p>
          </Alert>
          <Modal.Footer>
            <Button variant="primary" onClick={() => setModalShow(false)}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default ModalBloqueoEmision;

const List = styled.ul`
  font-size: 18px;
  list-style: none;
  font-family: 'Source Sans Pro';
  font-weight: 500 !important;
  padding-left: 0px;
  & > li {
    @media (min-width: 550px) {
      width: 480px !important;
    }
    @media (min-width: 650px) {
      width: 550px !important;
    }
    @media (min-width: 750px) {
      width: 650px !important;
    }
  }
`;
